<div class="assessment">

    <h3 class="text-center text-uppercase mt-4 mb-4" *ngIf="assessment">
        {{assessment.consentName}}
    </h3>

    <div
        class="form-group consent-pdf-actions"
        *ngIf="isPdfMode && (assessJSON?.merged_pdf_path || assessJSON?.pdf_path)"
    >
        <p class="small text-muted mb-2 consent-pdf-instructions">
            <strong>PDF form:</strong> a server-built PDF preserves the template layout (and adds an appendix for acknowledgments
            and signatures when available). A new tab opens with the full PDF — print from the viewer at <strong>100% / actual size</strong>
            (not shrink to fit).             You can also use <strong>Download</strong> or <strong>Open in new tab</strong>
            (the new tab may show a temporary <code>blob:</code> address — that is expected).
        </p>
        <button
            type="button"
            class="btn btn-sm btn-outline-secondary mr-1"
            (click)="downloadOriginalPdf()"
            [disabled]="pdfActionsLoading"
        >
            <span *ngIf="pdfActionsLoading" class="spinner-border spinner-border-sm mr-1" role="status"></span>
            Download PDF
        </button>
        <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            (click)="openOriginalPdfInNewTab()"
            [disabled]="pdfActionsLoading"
        >
            Open PDF in new tab
        </button>
        <p *ngIf="pdfActionsError" class="text-danger small mt-2 mb-0">{{ pdfActionsError }}</p>
    </div>

    <div class="form-group" *ngIf="!isPdfMode">
        <div [innerHtml]="assessJSONHTML"></div>
    </div>

    <div class="form-group consent-pdf-section" *ngIf="isPdfMode && (assessJSON?.merged_pdf_path || assessJSON?.pdf_path)">
        <p class="text-muted small mb-0 consent-pdf-on-file">
            <em>Full PDF is available via the buttons above (merged signed copy when generated).</em>
        </p>
    </div>

    <div class="form-group" *ngIf="answers && answers.length > 0">
        <h5 class="text-uppercase">Acknowledgments</h5>
        <ul class="list-unstyled">
            <li *ngFor="let a of answers" class="mb-2">
                <strong>{{ a.text }}</strong>
                <span *ngIf="a.required">*</span>
                <div *ngIf="a.type === 'yes_no'">
                    Answer: <span class="text-uppercase">{{ a.value || '—' }}</span>
                </div>
                <div *ngIf="a.type === 'free_text'">
                    <em>{{ a.value || '—' }}</em>
                </div>
            </li>
        </ul>
    </div>

    <div class="form-group patient-sig">
        <div class="text-center">
            <div class="signature"> <img src="{{ signatureUrl }}" /> </div>
            <h1 class="namesig">{{ assessJSON?.signatory}}</h1>
            <div> <label class="control-label text-center text-uppercase">Patient/Guardian Signature</label> </div>
        </div>
    </div>

    <div class="form-group guardian-sig" *ngIf="assessJSON?.signatory_staff && assessment?.guardianSignatureUrl">
        <div class="text-center">
            <div class="guardian_signature">
                <img src="{{ guardianSignatureUrl }}" />
            </div>
            <h1 class="namesig">{{ assessJSON.signatory_staff }}</h1>
            <div> <label class="control-label text-center text-uppercase">Dental Staff Signature</label>
            </div>
        </div>
    </div>
</div>
